<div class="content rasContent">
  <h2 class="title">{{ isEditing ? Texts.editTitle : Texts.title }}</h2>
  <mat-icon class="close-modal" (click)="closeModal()">close</mat-icon>
  <form [formGroup]="fraudeForm" class="selectRasForms formAlert">
    <div class="row">
      <div class="col-6 margTop contentRasSelectorForms">
        <mat-form-field appearance="outline">
          <mat-label>Tipo de persona *</mat-label>
          <mat-select
            formControlName="tipo_de_persona"
            (ngModelChange)="changeCi()"
            placeholder="Natural"
          >
            <!-- (ngModelChange)="changeCi()" -->

            <mat-option *ngFor="let person of typeOfPerson" [value]="person">
              {{ person }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div class="col-6 margTop contentRasSelectorForms">
        <mat-form-field appearance="outline">
          <mat-label>Número de Identificación *</mat-label>
          <input
            *ngIf="personId == 'V'"
            matInput
            formControlName="numero_de_identificacion"
            type="text"
            appNumberRange
            placeholder="Ingrese sólo números"
            [disabled]="!fraudeForm.value.tipo_de_persona"
          />
          <input
            *ngIf="personId == 'J'"
            matInput
            formControlName="numero_de_identificacion"
            type="text"
            appNumberRangeRif
            placeholder="Ingrese sólo números"
            [disabled]="!fraudeForm.value.tipo_de_persona"
          />

          <!-- (keyup)="changeCi()" -->
        </mat-form-field>
        <mat-error
          *ngIf="
            fraudeForm.get('numero_de_identificacion').hasError('pattern') &&
            personId == 'V'
          "
          >El número no puede tener menos de seis (06) ni más de nueve (9)
          dígitos.
        </mat-error>
        <mat-error
          *ngIf="
            fraudeForm.get('numero_de_identificacion').hasError('pattern') &&
            personId == 'J'
          "
          >El número no puede tener menos de nueve (9) dígitos y debe contener
          el formato ########-#.
        </mat-error>
      </div>
      <div class="col-4 margTop contentRasSelectorForms">
        <mat-form-field appearance="outline">
          <mat-label>Apellidos *</mat-label>
          <input
            matInput
            formControlName="apellido"
            type="text"
            appOnlyLetters
          />
        </mat-form-field>
        <mat-error *ngIf="fraudeForm.get('apellido').hasError('pattern')"
          >Formato inválido
        </mat-error>
      </div>

      <div class="col-4 margTop contentRasSelectorForms">
        <mat-form-field appearance="outline">
          <mat-label>Nombres *</mat-label>
          <input matInput formControlName="nombre" type="text" appOnlyLetters />
        </mat-form-field>
        <mat-error *ngIf="fraudeForm.get('nombre').hasError('pattern')"
          >Formato inválido
        </mat-error>
      </div>
      <div class="col-4 margTop contentRasSelectorForms">
        <mat-form-field appearance="outline">
          <mat-label>Oficina *</mat-label>
          <mat-select formControlName="oficina" placeholder="Oficina ">
            <mat-option
              *ngFor="let oficina of oficinasExample"
              [matTooltip]="oficina"
              [value]="oficina"
            >
              {{ oficina }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div class="col-4 margTop contentRasSelectorForms">
        <mat-form-field appearance="outline">
          <mat-label>Región *</mat-label>
          <mat-select formControlName="region" placeholder="Región ">
            <mat-option
              *ngFor="let region of regionesExample"
              [matTooltip]="region"
              [value]="region"
            >
              {{ region }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <div class="col-4 margTop contentRasSelectorForms">
        <mat-form-field appearance="outline">
          <mat-label>Teléfono principal *</mat-label>
          <input
            matInput
            placeholder="Ingrese sólo números"
            formControlName="telefono"
            type="text"
            appPhoneNumber
          />
        </mat-form-field>
        <mat-error *ngIf="fraudeForm.get('telefono').hasError('pattern')"
          >Formato <strong>invalido</strong>. Ingrese 11 dígitos</mat-error
        >
      </div>
      <div class="col-4 margTop contentRasSelectorForms">
        <mat-form-field appearance="outline">
          <mat-label>Correo electrónico *</mat-label>
          <input
            matInput
            placeholder="ejemplo@ejemplo.com"
            formControlName="correo"
            type="text"
          />
        </mat-form-field>
        <mat-error *ngIf="fraudeForm.get('correo').hasError('email')"
          >El correo es <strong>invalido</strong></mat-error
        >
        <mat-error *ngIf="fraudeForm.get('correo').hasError('pattern')"
          >Formato <strong>invalido</strong></mat-error
        >
      </div>
      <div class="col-6 margTop contentRasSelectorForms">
        <mat-form-field appearance="outline">
          <mat-label>Teléfono secundario *</mat-label>
          <input
            matInput
            placeholder="Ingrese sólo números"
            formControlName="celular"
            type="text"
            appPhoneNumber
          />
        </mat-form-field>
        <mat-error *ngIf="fraudeForm.get('celular').hasError('pattern')"
          >Formato <strong>invalido</strong>. Ingrese 11 dígitos</mat-error
        >
      </div>
      <div class="col-6 margTop contentRasSelectorForms">
        <mat-form-field appearance="outline">
          <mat-label>ID Cliente *</mat-label>
          <input matInput formControlName="cliente" type="text" />
        </mat-form-field>
      </div>

      <div class="col-12 margTop contentRasSelectorForms">
        <mat-form-field appearance="outline">
          <mat-label>Domicilio *</mat-label>
          <textarea matInput formControlName="domicilio"></textarea>
        </mat-form-field>
      </div>

      <h2 class="col-12"><b>Datos de la Alerta</b></h2>
      <div class="col-4 margTop contentRasSelectorForms">
        <mat-form-field appearance="outline">
          <mat-label>Canal *</mat-label>
          <mat-select formControlName="canal">
            <mat-option *ngFor="let canal of canalesExample" [value]="canal">
              {{ canal }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div class="col-4 margTop contentRasSelectorForms">
        <mat-form-field appearance="outline">
          <mat-label>Tipo de intrumento financiero *</mat-label>
          <mat-select
            formControlName="instrumento"
            (ngModelChange)="changeInstrument()"
          >
            <mat-option
              *ngFor="let instrumento of instrumentosExample"
              [value]="instrumento"
            >
              {{ instrumento }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div class="col-4 margTop contentRasSelectorForms">
        <mat-form-field appearance="outline">
          <mat-label>Prioridad *</mat-label>
          <mat-select formControlName="priority">
            <mat-option *ngFor="let pri of priority" [value]="pri">
              {{ pri }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div class="col-12 margTop contentRasSelectorForms">
        <mat-form-field appearance="outline">
          <mat-label>Descripción *</mat-label>
          <textarea matInput formControlName="descripcion"></textarea>
        </mat-form-field>
      </div>
      <div class="col-6 margTop contentRasSelectorForms">
        <mat-form-field style="width: 100%" appearance="outline">
          <mat-label>Fecha del evento *</mat-label>
          <input
            matInput
            formControlName="dateEvent"
            [matDatepicker]="picker3"
            [max]="today"
          />
          <mat-datepicker-toggle
            matSuffix
            [for]="picker3"
          ></mat-datepicker-toggle>
          <mat-datepicker #picker3></mat-datepicker>
        </mat-form-field>
      </div>

      <div class="col-6 margTop contentRasSelectorForms">
        <mat-form-field appearance="outline">
          <mat-label>Número del Instrumento *</mat-label>
          <input
            *ngIf="instrumentId == 'T'"
            appTarjetaValidator
            matInput
            formControlName="numberIdInstrumnet"
            type="text"
            placeholder="Ingrese tarjeta, sólo números"
            (focus)="holdingInput = true"
            (blur)="holdingInput = false"
          />
          <input
            *ngIf="instrumentId == 'C'"
            appCuentaValidator
            matInput
            formControlName="numberIdInstrumnet"
            type="text"
            placeholder="Ingrese cuenta, sólo números"
            (focus)="holdingInput = true"
            (blur)="holdingInput = false"
          />
        </mat-form-field>
        <p class="textGuia" *ngIf="holdingInput">
          Ingrese {{ instrumentId == "T" ? "16" : "" }}
          {{ instrumentId == "C" ? "20" : "" }} números
        </p>
      </div>
    </div>

    <!-- <case-files
      [(files)]="files"
      [(newFiles)]="newFiles"
      [(deleteFiles)]="deleteFiles"
      [isEditing]="isEditing"
    ></case-files> -->
  </form>
  <div class="tableTransactions">
    <form
      [formGroup]="formTable"
      class="selectRasForms formTable row"
      (ngSubmit)="addData()"
    >
      <h2 class="col-12 titleTransaction"><b>Transacción</b></h2>

      <div class="col-5 margTop classTableAddR classTableAdd">
        <mat-form-field appearance="fill">
          <mat-label>Monto de la Transacción *</mat-label>
          <input
            matInput
            formControlName="monto_salio"
            currencyMask
            type="text"
            placeholder="Ingrese sólo números"
          />
        </mat-form-field>
      </div>
      <div class="col-5 margTop classTableAddL classTableAdd">
        <mat-form-field appearance="fill">
          <mat-label>Referencia de la Transacción</mat-label>
          <input
            matInput
            formControlName="referenceTransaction"
            type="text"
            placeholder="Ingrese sólo números"
          />
        </mat-form-field>
      </div>
      <div class="col-2 padding">
        <div>
          <button
            class="buttonAddT"
            type="submit"
            [disabled]="formTable.invalid || submit"
          >
            Agregar
            <span
              ><img
                src="../../../../../../assets/images/icons/add_icon.png"
                alt=""
            /></span>
          </button>
        </div>
      </div>
    </form>
    <div class="task_content_table">
      <table mat-table #dataTable [dataSource]="dataSource" class="task_table">
        <ng-container matColumnDef="referenceTransaction">
          <th class="header-options" mat-header-cell *matHeaderCellDef>
            Referencia Transacción
          </th>
          <td mat-cell *matCellDef="let element">
            {{ element.referenceTransaction }}
          </td>
        </ng-container>

        <ng-container matColumnDef="monto_salio">
          <th class="header-options" mat-header-cell *matHeaderCellDef>
            Monto
          </th>
          <td mat-cell *matCellDef="let element">{{ element.monto_salio }}</td>
        </ng-container>
        <ng-container matColumnDef="opciones">
          <th class="header-options" mat-header-cell *matHeaderCellDef>
            Eliminar
          </th>
          <td mat-cell *matCellDef="let element; let i = index">
            <div class="options">
              <button class="delete" (click)="removerCuenta(i)">
                <i class="fas fa-times"></i>
              </button>
            </div>
          </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      </table>
      <mat-paginator
        [ngClass]="tableValues.length > 3 ? 'show' : 'notShow'"
        #paginator
        [length]="tableValues.length"
        [pageSizeOptions]="[3, 5, 10, 25, 50, 100]"
        [pageSize]="3"
        [showFirstLastButtons]
      >
      </mat-paginator>
    </div>
  </div>

  <div class="button">
    <button
      mat-raised-button
      class="primary-btn rounded buttonRas"
      [disabled]="!fraudeForm.valid || isLoading"
      (click)="save()"
    >
      {{ isEditing ? Texts.edit : Texts.create }}
    </button>
  </div>
</div>
